document.addEventListener("DOMContentLoaded", function () {
  const anchoredArticles = document.querySelectorAll(".anchored-article");

  anchoredArticles.forEach((articleContainer, containerIndex) => {
    const title_array = articleContainer.querySelectorAll(
      ".article-content .rte h2"
    );
    const anchors_block = articleContainer.querySelector(".privacy__anchors");
    const anchors_container = articleContainer.querySelector("#anchors-links");
    const rte = articleContainer.querySelector(".article-content .rte");
    const sidebarContainer = articleContainer.querySelector(
      ".col-lg-3 .sidebar-sticky"
    );


    function slugify(text) {
      return text
        .toString()
        .toLowerCase()
        .trim()
        .replace(/\s+/g, "-")
        .replace(/[^\w\-]+/g, "")
        .replace(/\-\-+/g, "-");
    }

    if (title_array.length && anchors_container) {
      title_array.forEach((title, index) => {
        const uniqueId =
          slugify(title.innerText) + "-" + containerIndex + "-" + index;
        title.setAttribute("id", uniqueId);

        const link = document.createElement("a");
        link.textContent = `${index + 1}. ${title.innerText}`;
        link.setAttribute("href", `#${uniqueId}`);
        anchors_container.appendChild(link);
      });
    } else if (anchors_block) {
      anchors_block.style.display = "none";
    }

    function updateAnchorsPosition() {
      if (!anchors_block || !rte) return;

      const firstP = rte.querySelector("p:first-child");
      const isMobile = window.innerWidth <= 991;
      const isAlreadyMobile =
        anchors_block.classList.contains("mobile-anchors");

      if (isMobile && !isAlreadyMobile) {
        if (firstP) {
          firstP.insertAdjacentElement("afterend", anchors_block);
          anchors_block.classList.add("mobile-anchors");
        }
      }

      if (!isMobile && isAlreadyMobile && sidebarContainer) {
        const firstChild = sidebarContainer.firstElementChild;
        if (firstChild !== anchors_block) {
          sidebarContainer.insertBefore(anchors_block, firstChild);
        }
        anchors_block.classList.remove("mobile-anchors");
      }
    }

    updateAnchorsPosition();
    window.addEventListener("resize", updateAnchorsPosition);

    if (anchors_container) {
      const links = anchors_container.querySelectorAll("a");

      function handleScroll() {
        const scrollPosition = window.scrollY + 150;
        let lastVisibleSection = null;

        title_array.forEach((section) => {
          const sectionTop = section.offsetTop;
          if (sectionTop <= scrollPosition) {
            lastVisibleSection = section.id;
          }
        });

        links.forEach((link) => {
          link.classList.remove("_active");
          if (
            lastVisibleSection &&
            link.getAttribute("href") === `#${lastVisibleSection}`
          ) {
            link.classList.add("_active");
          }
        });

        if (!lastVisibleSection && links.length > 0) {
          links[0].classList.add("_active");
        }
      }

      window.addEventListener("scroll", handleScroll, { passive: true });
      handleScroll();
    }
  });
});
